import { ICellRendererParams } from '@ag-grid-community/core'
import { SELECT_ALL } from '@helios/ag-grid-config'
import { fromUtc } from '@helios/utils'
import { formatDistance } from 'date-fns'
import {
  Account,
  humanReadableStatusTypes,
  perseusRunStatusTypes,
  ReconRunStatus,
} from '../models'

export const reconRunStatusTypesCellRenderer = (
  params: ICellRendererParams,
) => {
  let status = perseusRunStatusTypes[params.value as ReconRunStatus] ?? ''
  const account = params.node?.data as Account
  let lastReconRun = ''

  const runStatusShowTimestamps = [
    ReconRunStatus.FAILED,
    ReconRunStatus.FINISHED,
    ReconRunStatus.FAILED_ETLS,
    ReconRunStatus.FINISHED_ETLS,
  ]

  if (
    account?.lastPerseusRun &&
    runStatusShowTimestamps.includes(params.value)
  ) {
    lastReconRun = formatDistance(fromUtc(account.lastPerseusRun), new Date(), {
      addSuffix: true,
    })
  }

  if (status) {
    status = `${status} ${lastReconRun}`
  }

  return status
}

export const reconRunStatusTypesCellRendererWithText = (
  params: ICellRendererParams,
) => {
  const icon = perseusRunStatusTypes[params.value as ReconRunStatus] ?? ''
  const text = humanReadableStatusTypes[params.value as ReconRunStatus] ?? ''

  if (params.value === SELECT_ALL) {
    return SELECT_ALL
  }

  if (!icon) {
    return ''
  }

  return `${icon} ${text}`
}
